export const i18n = {
  documentDesc:
    '《雾影猎人》是一款全新黑暗奇幻动作PvPvE游戏，你可根据不同职业精心搭配技能、天赋、装备，领略第三人称视角下的精彩动作战斗体验。与队友配合或孤身作战，杀出重围满载而归。',
  documentKeywords:
    '雾影猎人,多人,夺金,撤离,动作,RPG,第三人称,PvPvE,黑暗奇幻,游戏,动作游戏,角色扮演,联机游戏',
  documentTitle: '《雾影猎人》官网|全新黑暗奇幻动作搜打撤游戏',
} as const;
